<template>
  <article
    v-click-outside="handleModalCloseAll"
    :class="bemBlockMod({ open: isModalOpen })"
  >
    <button
      v-if="buttonText"
      v-show="isBreakpointMobile && (!isOpen || !hideButtonOnOpen)"
      :class="[bemElement('btn'), 'btn', 'btn--cta']"
      @click="handleToggleModal"
    >
      {{ buttonText }}
    </button>
    <div
      :class="[
        bemElement('content'),
        noPadding ? bemElement('content-no-padding') : '',
        showModalClose && isBreakpointMobile
          ? bemElement('content-modal-close')
          : '',
      ]"
    >
      <button
        v-if="showModalClose"
        v-show="isBreakpointMobile"
        :class="[
          bemElement('btn-close', { hidden: !isModalOpen }),
          'btn-close',
        ]"
        @click.prevent="handleModalCloseAll"
      />
      <slot />
    </div>
  </article>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import windowResizeMixin from '../mixins/windowResizeMixin';
import getFrontConfig from '../../common/getFrontConfig';

const FRONT_CONFIG = getFrontConfig();

export default {
  name: 'BaseModalCTA',

  mixins: [bemClassesMixin, windowResizeMixin],

  props: {
    showModalClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideButtonOnOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonText: {
      type: String,
      required: false,
      default: '',
    },
    isOpen: {
      type: Boolean,
      required: true,
      default: false,
    },
    noPadding: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      isModalOpen: false,
      dataChangeBreakpoint: FRONT_CONFIG.responsive.bp_575,
    };
  },

  watch: {
    isOpen() {
      this.updateModalState();
    },
  },

  mounted() {
    this.updateModalState();
  },

  methods: {
    updateModalState() {
      if (this.isModalOpen !== this.isOpen) {
        this.isModalOpen = this.isOpen;
      }
    },
    handleToggleModal() {
      this.isModalOpen = !this.isModalOpen;
      this.$emit('modal:change-state', { isModalOpen: this.isModalOpen });
    },
    handleModalCloseAll() {
      if (this.isBreakpointMobile && this.isModalOpen) {
        this.isModalOpen = false;
        this.$emit('modal:close-all');
      }
    },
  },
};
</script>
